import React from 'react';
import styled from '@emotion/styled';
import { gaps } from 'components/layout/stack';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.button`
  display: flex;
  flex-direction: column;
  gap: ${gaps.md};
  padding: ${gaps.md};
  background: white;
  border: none;
  border-radius: 20px;
  max-width: 280px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
  text-align: start;
  transition: box-shadow 0.2s linear, opacity 0.2s linear;

  &:hover {
    opacity: 0.9;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }

  @media (min-width: 961px) and (max-width: 1100px) {
    max-width: 265px;
  }

  @media (max-width: 960px) {
    flex-direction: row;
    gap: ${gaps.sm};
    max-width: 500px;
    width: 100%;
    padding: ${gaps.sm};
  }
`;

const Image = styled.img`
  border-radius: 10px;
  width: 100%;

  @media (max-width: 960px) {
    width: 100px;
    height: 56.25px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: black;

  @media (max-width: 960px) {
    font-size: 18px;
  }
`;

const LevelBadge = styled.div`
  background: ${() => AppUI.site.secondaryAccentColor};
  color: white;
  font-size: 12px;
  line-height: normal;
  padding: 2px 10px;
  border-radius: 5px;
  display: inline-block;
  margin-right: ${gaps.xs};
  margin-top: 3px;

  @media (max-width: 960px) {
    margin-top: 1.5px;
    padding: 2px 5px;
    font-size: 10px;
    font-weight: bold;
  }
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: ${Theme.gray};
  line-height: normal;
  text-wrap: balance;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.xs};

  @media (min-width: 961px) {
    text-align: center;
  }
`;

const WelcomeScreenCard = ({ title, subtitle, imageUrl, levelAbbreviation, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <Image src={imageUrl} />
      <TextContainer>
        <Title>
          {levelAbbreviation && <LevelBadge>{levelAbbreviation}</LevelBadge>}
          {title}
        </Title>
        <Subtitle>{subtitle}</Subtitle>
      </TextContainer>
    </Wrapper>
  );
};

export default WelcomeScreenCard;